/**
 * nw-cart-complementary.js — <nw-cart-complementary>, complementary products in the cart drawer and on the cart page.
 *
 * Does the same job as Prestige's <product-recommendations>, which can't be used here. That element works out
 * which section to request with closest('.shopify-section'), but once the cart drawer has been used Prestige moves
 * <cart-drawer> out of its section and directly under <body>, so the lookup comes back empty and it throws on every
 * re-render after an add to cart. This element is given its section id by Liquid instead.
 *
 * The drawer swaps in freshly rendered HTML after every cart change, so connectedCallback runs again for each new
 * copy and fetches for whatever product is now the latest.
 */
(function () {
  'use strict';

  if (customElements.get('nw-cart-complementary')) return;

  customElements.define(
    'nw-cart-complementary',
    class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        this.load();
      }

      async load() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url =
          root +
          'recommendations/products?product_id=' + encodeURIComponent(this.getAttribute('product')) +
          '&limit=' + encodeURIComponent(this.getAttribute('limit') || 6) +
          '&section_id=' + encodeURIComponent(this.getAttribute('section-id')) +
          '&intent=complementary';

        try {
          var response = await fetch(url);
          if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);

          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var rendered = doc.querySelector('nw-cart-complementary');

          // A newer copy may have replaced this one while the request was in flight.
          if (!this.isConnected) return;

          if (rendered && rendered.childElementCount > 0) {
            this.replaceChildren.apply(this, Array.from(document.importNode(rendered, true).childNodes));
            this.hidden = false;
          } else {
            this.remove();
          }
        } catch (error) {
          console.error('Cart complementary products:', error);
          if (this.isConnected) this.remove();
        }
      }
    }
  );
})();
